// "One deal. Double the payout." example: AED 110,000 commission (5% of the price).
export const PAYOUT_EXAMPLE_COMMISSION_AED = 110_000;
export const PAYOUT_EXAMPLE_BROKERAGE_PERCENT = 40;

// "3 ways your brokerage is costing you" market bars (brokerage splits, not our config).
export const MARKET_TYPICAL_SPLIT_PERCENT = 50;
export const MARKET_TOP_AGENT_SPLIT_PERCENT = 70;

export const LANDING_FACTS_TIMEOUT_MS = 3000;

// Hero search widget: default featured rows ("Emaar in Dubai Marina", topped up with recent projects).
export const HERO_FEATURED_COUNT = 4;
export const HERO_FEATURED_DEVELOPER = 'Emaar';
export const HERO_FEATURED_AREA = 'Dubai Marina';
export const HERO_FEATURED_CANDIDATES = 12;
export const HERO_FEATURED_CACHE_TTL_MS = 10 * 60 * 1000;
// The catalogue total is shown rounded down to this step with a "+" ("1,200+").
export const HERO_TOTAL_ROUNDING_STEP = 100;
